import React from 'react';
import VegaChart from './vega/VegaChart';

class WidgetChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    };
  }

  render() {
    return (
      <div className="c-widget-chart">
        {this.props.title &&
          <h5 className="title -light">{this.props.title}</h5>
        }
        <VegaChart data={this.props.widgetConfig} toggleLoading={this.props.toggleLoading} />
      </div>
    );
  }
}

WidgetChart.propTypes = {
  widgetConfig: React.PropTypes.object.isRequired,
  title: React.PropTypes.string,
  toggleLoading: React.PropTypes.func
};

export default WidgetChart;



// WEBPACK FOOTER //
// ./app/components/common/WidgetChart.jsx